import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PreSales.scss';
import '../../../../theme/form-style-label-animation.scss';
import { Form, Field } from 'react-final-form';
import { required } from '../../../../utils/validation';
import { composeValidators } from '../../../../utils/helper';
import { preSalesUserLogin } from '../../../../actionCreators/checkout';


class PreSales extends Component {
    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
    }
    componentDidUpdate() {
        const { leadSource } = this.props;
        if (leadSource) {
            window.location.href = '/checkout/onepage/presales';
        }
    }
    handleLogin = value => {
        const { preSalesUserLogin } = this.props;
        const data = {
            userName: value.login_id,
            password: value.password
        };
        preSalesUserLogin(data);
    }

    render() {
        const { preSalesUserData, loading } = this.props;
        const { message: error, userName: successMessage } = preSalesUserData || '';
        return (
            <div className="presales-wrapper">
                <div className="padding-t15 padding-b15 padding-r20 padding-l20 presales-heading text-center fs16">Login - PreSales Checkout</div>
                {error && <div className="form-SLA_field-row_error text-center">
                    <p className="fw700 margin-t10">{error}</p>
                </div>}
                {successMessage && <div className="form-SLA_field-row_success text-center padding-t10 fs15">Logged In. Redirecting to checkout page</div>}
                <Form
                    onSubmit={this.handleLogin}
                    render={
                        ({ handleSubmit }) => {
                            return (
                                <form onSubmit={handleSubmit} name="register" className="presales-form padding-t30 paddingb-30" noValidate>
                                    <div className="form-row">
                                        <label className="fs15">Login id</label>
                                        <Field name="login_id" validate={required}>
                                            {({ input, meta }) => (
                                                <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                                    <input {...input} type="text" ref="login_id" className={meta.valid || meta.error && meta.dirty ? '' : 'validate-email'} title="Email Address" placeholder="Please enter Username" />
                                                    {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="form-row margin-t10">
                                        <label className="fs15">Password</label>
                                        <Field name="password" validate={composeValidators(required)}>
                                            {({ input, meta }) => (
                                                <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                                    <input {...input} type="password" ref="password" className={meta.valid || meta.error && meta.dirty ? '' : 'validate-password'} title="Password" placeholder="Please enter password" />
                                                    {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="form-row margin-t15">
                                        <button type="submit" className="form-SLA_field-row_submit" name="send">
                                        {loading ? <img src="https://static.lenskart.com/media/desktop/img/preloader.png" alt="loader" style={{ width: '20px' }} />
                                        : (
                                            <span className="block">
                                                Login
                                            </span>
                                        )}
                                        </button>
                                    </div>
                                    {/* <div className="form-row margin-b20 margin-t10 text-center">
                                        <a className="fs14 display-ib btn-change-password">Change Password</a>
                                    </div> */}
                                </form>
                        );
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        leadSource: state.checkout.leadSource,
        preSalesUserData: state.checkout.preSalesUserData,
        loading: state.checkout.preSalesloading,
        submitSuccess: state.checkout.submitSuccess
    };
};
const mapDispatchToProps = dispatch => {
    return {
        preSalesUserLogin: data => dispatch(preSalesUserLogin(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreSales);
